import { useState } from 'react';
import { notifyError } from '../services/notify';

interface Props {
  value: string;
  onSave: (newValue: string) => Promise<unknown> | void;
  onValueClick?: () => void;
  existingValues?: string[];
  disabled?: boolean;
  inputStyle?: React.CSSProperties;
}

export function EditableText({ value, onSave, onValueClick, existingValues, disabled, inputStyle }: Props) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const start = () => {
    setDraft(value);
    setEditing(true);
  };

  const cancel = () => setEditing(false);

  const commit = async () => {
    const trimmed = draft.trim();
    if (!trimmed || trimmed.toLowerCase() === value.toLowerCase()) {
      cancel();
      return;
    }
    if (existingValues?.some(v => v.toLowerCase() === trimmed.toLowerCase())) {
      notifyError('That name already exists.');
      cancel();
      return;
    }
    try {
      await onSave(trimmed);
    } finally {
      setEditing(false);
    }
  };

  if (editing) {
    return (
      <input
        autoFocus
        style={{ width: 120, ...inputStyle }}
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={e => {
          if (e.key === 'Enter') { e.preventDefault(); commit(); }
          if (e.key === 'Escape') cancel();
        }}
        onClick={e => e.stopPropagation()}
      />
    );
  }

  return (
    <>
      {onValueClick ? (
        <a style={{ cursor: 'pointer' }} onClick={onValueClick}>{value}</a>
      ) : (
        <span>{value}</span>
      )}
      {!disabled && (
        <i
          className="fas fa-pencil-alt text-muted iio-inline-edit-icon"
          style={{ marginLeft: 6, cursor: 'pointer' }}
          onClick={e => { e.stopPropagation(); start(); }}
        />
      )}
    </>
  );
}
